import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors/ui/dropdown';

/** @returns {boolean} */
export const isLoadingSelector = createSelector(getParent, ({ isLoading } = {}) => isLoading ?? false);
